import ActiveChannel          from '@/channel.active';

import activeComponent        from './active.component';

import chargerListViewModule  from './changer-list-view/changer-list-view';
import searchModule           from './search/search';
import { validatorDirective } from './validator/validator.directive';
import {validatorButtonDirective} from "./validator/validator-button.directive";


const activeModule = angular
  .module('activeModule', [
    chargerListViewModule.name,
    searchModule.name
  ])
  .component('active', activeComponent)
  .service('$channel', ActiveChannel)
  .directive('validator', validatorDirective.create)
  .directive('validatorButton', validatorButtonDirective.create);

export default activeModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/active/active.js
 **/